<div [ngBusy]="{busy: fetchSubscription, message: 'Loading Workflow Status ...'}"></div>
<ngb-accordion *ngFor="let od of overviewData | keyvalue">
  <ngb-panel>
    <ng-template ngbPanelHeader let-opened="opened">
      <div class="d-flex align-items-center justify-content-between">
        <h5 class="m-0">{{od.key}}</h5>
        <button ngbPanelToggle class="btn btn-link p-0">{{opened ? 'Hide' : 'Show'}}</button>
      </div>

      <div *ngIf="od.value.notstarted">
          <p class="text-warning">Not Started</p>
      </div>

      <div *ngIf="!od.value.notstarted">
        <ngb-progressbar [type]="od.value.status"
                         [max]="od.value.numtasks"
                         [value]="od.value.passedtasks">{{od.value.passedtasks}} of {{od.value.numtasks}}
        </ngb-progressbar>
        <div *ngIf="od.value.startedtasks > 0">
          <b>Running:</b>
          <p *ngFor="let r of od.value.running" class="text-info">{{r}}</p>
        </div>
        <div  *ngIf="od.value.failedtasks > 0">
          <b>Failed:</b>
          <p *ngFor="let r of od.value.failed" class="text-danger">{{r}}</p>
        </div>
      </div>
    </ng-template>
    <ng-template ngbPanelContent>
      <table class="table table-sm">
        <thead class="thead-dark">
          <th>Posted</th>
          <th>Time</th>
          <th>Mode</th>
          <th>Task Group</th>
          <th>Task</th>
          <th>Status</th>
          <th>Summary</th>
        </thead>
        <tbody>
          <tr *ngFor="let task of od.value.tasks" [ngClass]="{'text-success' : task.status === 'PASS',
                            'text-info' : task.status === 'STARTED',
                            'text-warning' : task.status === 'PENDING',
                            'text-danger' : task.status === 'FAIL'}">
            <td >{{task.posted}}</td>
            <td>{{task.time}}</td>
            <td>{{task.mode}}</td>
            <td>{{task.taskgroup}}</td>
            <td><a [routerLink]="['/workflow', od.key, task.task]"
                   [ngClass]="{'text-success' : task.status === 'PASS',
                            'text-info' : task.status === 'STARTED',
                            'text-warning' : task.status === 'PENDING',
                            'text-danger' : task.status === 'FAIL'}">
              {{task.task}}
            </a></td>
            <td>{{task.status}}</td>
            <td>{{task.summary}}</td>
          </tr>
        </tbody>
      </table>
    </ng-template>
  </ngb-panel>
</ngb-accordion>
